import * as React from 'react';
import * as styles from './MercadoPagoIcon.scss';

export default (props: any) => (
  <img
    className={styles.mercadoPagoLogo}
    src="https://www.wix.com/_partials/third-party/cashier-settings/methods-new/method-icon-mercadoPago-new.svg"
    style={props.style}
  />
);



// WEBPACK FOOTER //
// ./components/icons/MercadoPagoIcon/MercadoPagoIcon.tsx